import PropTypes from "prop-types"

// Helper function to get sort direction for ARIA
const getSortDirection = (sorter, field) => {
  if (!sorter || sorter.field !== field) return "none"
  return sorter.order === "ascend" ? "ascending" : "descending"
}

const getHeaders = (sorter) => [
  {
    title: "Date sent",
    dataIndex: "date_sent",
    key: "date_sent",
    sorter: true,
    width: "25%",
    ellipsis: true,
    "aria-sort": getSortDirection(sorter, "sort_by_date_sent"),
    "aria-label": "Date Sent, sortable"
  },
  {
    title: "Message",
    dataIndex: "message",
    key: "message",
    "aria-label": "Message"
  }
]

getHeaders.propTypes = {
  sorter: PropTypes.object
}

export { getHeaders }
